export const LOCK_NODE_EDITOR_CLASSNAME = "lock-on-focus" as const;
